export const defaultThreadFinisherText = (userName) => {
  return `That's a wrap!\n
If you enjoyed this thread:\n
1. Follow me @${userName} for more of these
2. RT the tweet below to share this thread with your audience`
}